import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import { RootScopeService } from '../../../services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-interaction-history-brief-view',
  templateUrl: './interaction-history-brief-view.component.html',
  styleUrls: ['./interaction-history-brief-view.component.scss'],
})
export class InteractionHistoryBriefViewComponent implements OnInit, OnChanges {
  @Output() viewAllIHList: EventEmitter<any> = new EventEmitter();
  isDataPresent: boolean = false;
  @Input() id: any;


  iconConfig: any;
  IHBriefViewLoader: boolean = false;
  showLoaderMsg: boolean = false;
  loaderTimeoutId: any;
  apiFailed: boolean = false;
  apiFailureMsg = Constants.CARD_DATA_FAILURE_MSG;
  selected: any;
  displayAlert: boolean = false;

  constructor(
    public intHistService: InteractionHistoryService,
    private apiService: ApiService,
    public rootScopeService: RootScopeService
  ) {
    this.iconConfig = {
      iconName: 'arrow-right',
      iconType: 'light',
      iconPlacement: 'right',
    };
    this.intHistService.refreshIHData.subscribe({
      next: (res: boolean) => {
        if (res && this.intHistService.refreshBriefData) { 
          this.getData();
          this.intHistService.refreshBriefData=false; 
        }
      },
      error: (err: string) => { console.log(err) }
    })
  }

  totalRecords: number = 5;

  ngOnInit(): void {
    // console.log("in CA ngOnit called")
    this.apiFailed = false;
  }

  ngOnChanges(changes) {
    // console.log("changes", changes)
    if (changes.id.currentValue != changes.id.previousValue) {
      this.checkDataState()
    }
  }


  /**
   * Method to check whether tableData is already present 
   * for existing CS id .If yes what kind of data
   * a)Api failure
   * b)No data found
   * c)data present.
   * accordingly updating variables and UI
   * @author : Pooja Gupta
   */
  checkDataState() {
    let data = this.intHistService.IHBriefViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId];
    // console.log("data", data)
    if (data) {
      if (data == "apiFailed") {
        this.rootScopeService.activeCustTab.IHBriefViewData.apiFailed = true;
        this.rootScopeService.activeCustTab.IHBriefViewData.isDataPresent = false;
      }
      else if (data?.filteredData?.length == 0) {
        this.rootScopeService.activeCustTab.IHBriefViewData.apiFailed = false;
        this.rootScopeService.activeCustTab.IHBriefViewData.isDataPresent = false;
      }
      else {
        this.intHistService.interHistBriefViewTableData = data;
        this.rootScopeService.activeCustTab.IHBriefViewData.isDataPresent = true;
        this.rootScopeService.activeCustTab.IHBriefViewData.apiFailed = false;
      }
    }
    else {
      this.getData();
    }
  }

 


  /**
   * Below method hits the api 
   * and modify the resonse.
   * @author : Pooja Gupta
   */

  getData() {
    this.IHBriefViewLoader = true;
    this.startTimerForLoader();
    this.apiService.getIHDataForBriefView().subscribe(
      {
        next: (data: any) => {  
          this.apiFailed = false;
          if (data['data'] && data['data'].length > 0) {
            this.intHistService.modifyIHBriefViewData(data['data']);
            this.rootScopeService.activeCustTab.IHBriefViewData.isDataPresent = true;

          }
          else {
            this.rootScopeService.activeCustTab.IHBriefViewData.isDataPresent = false;
            this.intHistService.IHBriefViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId] = new MatTableDataSource([])
          }           
          this.IHBriefViewLoader = false;
          this.showLoaderMsg = false;
          clearTimeout(this.loaderTimeoutId);
        },
        error: (error) => {         
          this.rootScopeService.activeCustTab.IHBriefViewData.apiFailed = true;
          this.IHBriefViewLoader = false;
          this.showLoaderMsg = false;
          this.intHistService.IHBriefViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId] = "apiFailed"
          clearTimeout(this.loaderTimeoutId);
        },
      })
  }


  startTimerForLoader() {
    let that = this;
    /*istanbul ignore next */
    this.loaderTimeoutId = setTimeout(() => { 
      that.showLoaderMsg = true;
    }, 1 * this.rootScopeService.showLoaderMsgThreshold * 1000);
  }


  onRowSelection(event) {
    this.goToListViewIHPage(event, true);
  }

  goToListViewIHPage(event, source) {
    // console.log("event", event)
    this.rootScopeService.activeCustTab.IHSelectedRow = event;
    if (source)
      this.viewAllIHList.emit(event);
    else
      this.viewAllIHList.emit({});
  }

  errorMsgForIHSentence1(){
    return `${Constants.CUST_IH_POST_60_DAYS_FIRST_SENTENCE}`;
  }

  errorMsgForIHSentence2(){
    return `${Constants.CUST_IH_POST_60_DAYS_SECOND_SENTENCE}`;
  }


  closeWarning() {
    this.rootScopeService.activeCustTab.showRepeatAlertBriefView = !this.rootScopeService.activeCustTab.showRepeatAlertBriefView
  }
}
